function syncAppearance() {
  const dark = document.documentElement.dataset.srTheme !== 'light';
  document.querySelectorAll('[data-sr-appearance]').forEach(button => {
    button.setAttribute('aria-label', 'Switch to ' + (dark ? 'light' : 'dark') + ' mode');
    button.innerHTML = dark ? '☼ <span>Light</span>' : '☾ <span>Dark</span>';
  });
}
document.addEventListener('click', event => {
  if (!event.target.closest('[data-sr-appearance]')) return;
  const theme = document.documentElement.dataset.srTheme === 'light' ? 'dark' : 'light';
  document.documentElement.dataset.srTheme = theme;
  try { localStorage.setItem('sr-appearance', theme); } catch { /* The preference is optional. */ }
  syncAppearance();
});
syncAppearance();
